import {
  hasCompletePriceRange,
  type PriceRangeValues,
} from "@/components/marketplace/has-complete-price-range";

function clampPercent(value: number) {
  return Math.min(100, Math.max(0, value));
}

export function offerPriceRangePosition(input: PriceRangeValues) {
  if (!hasCompletePriceRange(input)) return 50;
  const { current, minimum, average, maximum } = input;

  if (maximum <= minimum) return 50;
  if (current === average) return 50;

  if (current < average) {
    if (average <= minimum) return current <= minimum ? 0 : 50;
    return clampPercent((50 * (current - minimum)) / (average - minimum));
  }

  if (maximum <= average) return current >= maximum ? 100 : 50;
  return clampPercent(50 + (50 * (current - average)) / (maximum - average));
}
